<template>
  <el-dialog
    title="跟进学员"
    :visible.sync="dialogVisible"
    width="800px"
    custom-class="MyDialog"
    :close-on-click-modal="false"
    >
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane v-if="currentCustomId" label="添加跟进" name="first">
        <el-form ref="form" :model="followUpForm" :rules="follupRules" label-width="130px" class="followUpForm">
          <el-form-item label="学员姓名：" prop="customName">
            <span>{{followUpForm.customName}}</span>
          </el-form-item>
          <el-form-item label="客户意向度：" prop="intend">
            <el-select v-model="followUpForm.intend" placeholder="请选择客户意向度" style="width: 300px">
              <el-option v-for="(item, index) in intendList" :key="`intend_${index}`" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="跟进状态：" prop="followStatus">
            <el-select v-model="followUpForm.followStatus" placeholder="请选择跟进状态" style="width: 300px">
              <el-option v-for="(item, index) in followStatuslist" :key="`intend_${index}`" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="学员标签：" prop="label">
            <ul class="label-ul">
              <li v-for="(item, index) in LabelList" :key="item.id" :class="[item.isChecked ? 'actived' : '']" @click="chooseLabel(index)">
                <span>{{item.labelName}}</span>
              </li>
            </ul>
          </el-form-item>
          <el-form-item label="话务沟通状态：" prop="communicationStatus">
            <ul class="label-ul">
              <li v-for="(item, index) in communicationStatusList" :key="item.id" :class="[item.checked ? 'actived' : '']" @click="chooseCommunicationStatus(index)">
                <span>{{item.name}}</span>
              </li>
            </ul>
          </el-form-item>
          <el-form-item label="跟进内容" prop="communicateContent">
            <p class="tips">如：今天是第几次跟进；讲解了松鼠Ai的优势等；学员的意向科目是什么；<br>家长态度如何;是否预约下次跟进等...</p>
            <el-input type="textarea" rows="4" v-model="followUpForm.communicateContent" placeholder="请输入跟进内容" style="width: 300px"></el-input>
            <div>
              <span>支持jpg/png格式，最佳尺寸1080x1920，大小不超过5MB</span>
              <a class="credential-instance" @click="previewImage"
                >凭证实例</a
              >
            </div>
            <el-upload
                ref="upload"
                :class="['upload-demo', {hide_box: upload_btn}]"
                action="#"
                accept=".jpg,.jpeg,.png"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                :on-change="handleSetUploadData"
                multiple
                :limit="1"
                :auto-upload="false"
                :on-exceed="handleExceed"
                :file-list="fileList"
                list-type="picture-card"
              >
                <i slot="default" class="el-icon-plus"></i>
                <div slot="file" slot-scope="{ file }">
                  <img
                    class="el-upload-list__item-thumbnail"
                    :src="file.url"
                    alt=""
                  />
                  <span class="el-upload-list__item-actions">
                    <span
                      class="el-upload-list__item-preview"
                      @click="handlePictureCardPreview(file)"
                    >
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <span
                      v-if="!disabled"
                      class="el-upload-list__item-delete"
                      @click="handleRemove(file)"
                    >
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
              </el-upload>
          </el-form-item>
          <el-form-item label="下次沟通时间：" prop="intend">
            <el-col :span="8">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="followUpForm.communicateDate"
                style="width: 100%"
                :picker-options="{ disabledDate: time => time.getTime() < Date.now() - 8.64e7 }"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-col>
            <el-col :span="6">
              <el-time-picker placeholder="选择时间" v-model="followUpForm.communicateTime" style="width: 100%" value-format="hh:mm:ss"></el-time-picker>
            </el-col>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!--完善资料-->
      <el-tab-pane label="完善资料" name="second">
        <el-form ref="messageForm" :model="messageForm" :rules="messageRules" label-width="120px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="学员姓名：" prop="customName">
                <el-input v-model="messageForm.customName" :disabled="studentData.customName?(this.Master_Edit_Custom?false:true):false"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机号：" prop="phone">
                <el-input placeholder="请输入手机号" v-model="messageForm.phone" class="input-with-select" maxlength="11">
                  <el-select v-model="messageForm.relationStr" slot="prepend" placeholder="请选择" style="width: 90px">
                    <el-option v-for="(item, index) in relationshipList" :key="`schools1_${index}`" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="性别：" prop="sex">
                <el-radio-group v-model="messageForm.sex">
                  <el-radio :label="1">男</el-radio>
                  <el-radio :label="2">女</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="出生日期：" prop="birthday">
                <el-date-picker type="date" placeholder="选择出生日期" v-model="messageForm.birthday" style="width: 100%;" format="yyyy-MM-dd"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="家庭住址：" prop="homeAddress">
                <el-input v-model="messageForm.homeAddress" placeholder="请输入家庭地址"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="学员类型：" prop="customType">
                <el-select v-model="messageForm.customType" placeholder="请选择学员类型" style="width: 100%" disabled>
                  <el-option v-for="(item, index) in studentsTypeList" :key="`studentsType_${index}`" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="阶段年级：" prop="stage">
                <el-col :span="12">
                  <el-select v-model="messageForm.stage" placeholder="请选择阶段" @change="changeStage">
                    <el-option v-for="(item, index) in schoolType" :key="`schoolType_${index}`" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-col>
                <el-col :span="12">
                  <el-select v-model="messageForm.grade" placeholder="请选择年级">
                    <el-option v-for="(item, index) in schools" :key="`schools_${index}`" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="来源：" prop="firstSource">
                <el-cascader
                  style="width: 100%"
                  v-model="messageForm.firstSource"
                  :options="sourceList"
                  @change="handleChange">
                </el-cascader>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="学员学校：" prop="school">
                <el-select v-model="messageForm.school" placeholder="请选择学员学校" style="width: 100%">
                  <el-option v-for="(item, index) in PublicSchool" :key="`schools_${index}`" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="课程顾问：" prop="ownerId">
                <el-select v-model="messageForm.school" placeholder="请选择学员类型" style="width: 100%">
                  <el-option label="区域一" value="shanghai"></el-option>
                  <el-option label="区域二" value="beijing"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="联系人1：" prop="relationBackup">
                <el-input placeholder="请输入联系人1" v-model="messageForm.phoneBackup" class="input-with-select" maxlength="11">
                  <el-select v-model="messageForm.relationBackup" slot="prepend" placeholder="请选择" style="width: 90px">
                    <el-option v-for="(item, index) in relationshipList" :key="`schools2_${index}`" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系人2：" prop="relationBackupTwo">
                <el-input placeholder="请输入联系人2" v-model="messageForm.phoneBackupTwo" class="input-with-select" maxlength="11">
                  <el-select v-model="messageForm.relationBackupTwo" slot="prepend" placeholder="请选择" style="width: 90px">
                    <el-option v-for="(item, index) in relationshipList" :key="`schools3_${index}`" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="联系人3：" prop="relationBackupThree">
                <el-input placeholder="请输入联系人3" v-model="messageForm.phoneBackupThree" class="input-with-select" maxlength="11">
                  <el-select v-model="messageForm.relationBackupThree" slot="prepend" placeholder="请选择" style="width: 90px">
                    <el-option v-for="(item, index) in relationshipList" :key="`schools4_${index}`" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注：" prop="remark">
                <el-input
                  type="textarea"
                  :rows="5"
                  placeholder="500字以内"
                  maxlength="500"
                  v-model="messageForm.remark">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-tab-pane>
    </el-tabs>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeFollowUpDialog">关 闭</el-button>
      <el-button type="primary" @click="submitSave">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getDictionaryList, OriginTypelist, getLabelList } from "@/api/basicApi";
import { getBaseUrl } from "@/util/config";
import { addRecord, customArticle, updateCallInfo } from "@/api/studentDetails";
import {addEditCustomer} from "@/api/studentDetails";
import { unlocking } from "@/util/accessControl";
import { CRM_STUDENT_LABEL} from "@/util/keys";
import axios from "axios";
import LoginUserHelper from "@/util/LoginUserHelper";

export default {
  data() {
    return {
      activeName: 'first',
      dialogVisible: true,
      followUpForm: {
        customName: '',
        phone: '',
        intend: '',
        followStatus: '',
        labels: '',
        communicateContent: '',
        nextCommunicateTime: '',
        communicateDate: '',
        communicateTime: '',
      },
      LabelList: [],
      messageRules: {
        customName: [
          { required: true, message: '请输入学员姓名', trigger: 'blur' },
          { min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
      },
      follupRules: {
        communicationStatus: [
          { required: true, message: '请选择话务沟通状态', trigger: 'blur' }
        ],
        communicateContent: [
          { required: true, message: '请填写跟进内容', trigger: 'blur' }
        ],
      },
      messageForm: {
        customName: '',
        sex: 1,
        phone: '',
        relation: '',
        relationStr: 6002001,
        relationBackup: 6002001,
        phoneBackup: '',
        relationBackupTwo: 6002001,
        phoneBackupTwo: '',
        relationBackupThree: 6002001,
        phoneBackupThree: '',
        birthday: '',
        homeAddress: '',
        customType: '',
        stage: '',
        grade: '',
        firstSource: '',
        school: [],
        remark: '',
        schoolId: '',
      },
      intendList: [],
      followStatuslist: [],
      fileList: [],
      studentsTypeList: [], // 学员类型
      schoolType: [
        {
          id: 6003004,
          name: "学前"
        },
        {
          id: 6003001,
          name: "小学"
        }, {
          id: 6003002,
          name: "初中"
        }, {
          id: 6003003,
          name: "高中"
        }], //学段
      schoolData: [], //年级
      upload_btn: false,
      sourceList: [],
      relationshipList: [],//关系
      ownerId: '',
      schools: [],
      PublicSchool: [],
      firstSource: '',
      schoolData: {
        '6003004': [
          {
            id: 6004023,
            name: "小班",
          },
          {
            id: 6004024,
            name: "中班",
          },
          {
            id: 6004025,
            name: "大班",
          },
        ],
        '6003001': [{
            id: 6004001,
            name: "一年级"
        }, {
            id: 6004002,
            name: "二年级"
        }, {
            id: 6004003,
            name: "三年级"
        }, {
            id: 6004004,
            name: "四年级"
        }, {
            id: 6004005,
            name: "五年级"
        }, {
            id: 6004006,
            name: "六年级"
        }],
        '6003002': [{
            id: 6004006,
            name: "六年级"
        },{
            id: 6004007,
            name: "七年级"
        }, {
            id: 6004008,
            name: "八年级"
        },  {
            id: 6004009,
            name: "九年级"
        }],
        '6003003': [{
            id: 6004010,
            name: "高一"
        }, {
            id: 6004011,
            name: "高二"
        },  {
            id: 6004012,
            name: "高三"
        },  {
            id: 6004013,
            name: "高四"
        }],
      },
      studentData: {},
      Master_Edit_Custom: unlocking('Master_Edit_Custom'),
      communicationStatusList: [],
      selectLabelNoArr: [],
      selectCallStatus: [],
      disabled: false,
      uploadPictureObj: {
        fileName: '',
        fileUrl: '',
      },
    }
  },
  props: {
    showFollowUpDialog: {
      type: Boolean,
      default: false
    },
    currentCustomId: {
      type: String,
      default: 1,
    },
    followUpState: {
      type: Boolean,
      default: false
    },
  },
  watch: {
    showFollowUpDialog: {
      handler(newVal, oldVal) {
        this.dialogVisible = newVal;
        if (!this.followUpState && this.currentCustomId) {
          updateCallInfo({customId: this.currentCustomId}).then(res=>{});
          this.loadStudentDetal();
        }
      },
      immediate: true
    },
    currentCustomId: {
      handler(newVal, oldVal) {
        if (newVal == 1) {
          this.activeName = 'first';
        } else {
          this.activeName = 'second';
        }
      },
      immediate: true
    }
  },
  mounted() {
    let userInfo = LoginUserHelper.getUserInfo();
    getLabelList({campusId: userInfo.campusId}).then( ret => {
      if (ret.code === 0) {
        sessionStorage.setItem(CRM_STUDENT_LABEL, JSON.stringify(ret.data))
          // this.setState({LabelList: ret.data.map(item => {
          //         return {
          //             ...item,
          //             checked: startVal.indexOf(item.labelNo) >= 0
          //         }
          //     })})
        this.LabelList = ret.data;
        this.LabelList.map(item => {
          item['isChecked'] = false;
        })
      }
    })

    getDictionaryList({ typeId: 1021 }).then(ret => {
      if (ret.code === 0) {
        ret.data.forEach((item)=>{
          if (item.id === 1021001) {
            item.checked = true
          } else {
            item.checked = false
          }
        })
        // let checkedValue = ret.data.filter(item => {
        //     return item.checked
        // }).map(item => {
        //     return item.id
        // })
        // this.props.form.setFieldsValue({callStatus: checkedValue})
        // this.setState({
        //     communicationStatusList: ret.data
        // })
        this.communicationStatusList = ret.data;
      }
    })

    getDictionaryList({ typeId: 6007 }).then(ret => {
      if (ret.code === 0) {
        this.intendList = ret.data;
      }
    })
    getDictionaryList({ typeId: 6005 }).then(ret => {
      if (ret.code === 0) {
        this.followStatuslist = ret.data;
      }
    })
    //学员类型
    getDictionaryList({ typeId: 6006 }).then(ret => {
      if (ret.code === 0) {
        this.studentsTypeList = ret.data;
      }
    })
    //学段
    getDictionaryList({typeId: 6003}).then(ret => {
      this.schoolType = ret.data;
    })
    getDictionaryList({typeId: 6004}).then(ret => {
      if (ret.code === 0) {
        this.schoolData = {
          '6003004': ret.data.slice(0, 3),
          '6003001': ret.data.slice(3, 9),
          '6003002': ret.data.slice(8, 12),
          '6003003': ret.data.slice(12, 15),
        }
      }
    })
    // 来源
    OriginTypelist().then(ret => {
      if (ret.code === 0) {
        ret.data.forEach(item => {
          if (item.children) {
            item.children.find(item0 => {
              if (item0.value === this.firstSource) {
                  // this.props.form.setFieldsValue({
                  //     firstSource: [item.value, this.state.studentData.firstSource]
                  // })
              }
              return item0.value === this.firstSource
            })
          }
      })
      this.sourceList = (ret.data || []).filter(item => {
        return item.children && (item.children.length > 0)
      })
      }
    })
    //关系
    getDictionaryList({typeId: 6002}).then(ret => {
      if (ret.code === 0) {
        this.relationshipList = ret.data;
      }
    })

  },
  methods: {
    chooseCommunicationStatus(selectIndex) {
      this.communicationStatusList.map((item, index) => {
        let oldItem = item;
        if (index == selectIndex) {
          oldItem['checked'] = !oldItem['checked'];
          this.$set(this.communicationStatusList, index, oldItem);
        } else {
          oldItem['checked'] = false;
          this.$set(this.communicationStatusList, index, oldItem);
        }
      })
      this.communicationStatusList.map(item => {
        if (item['checked']) {
          this.selectCallStatus.push(item.id);
        }
      })
    },
    chooseLabel (index) {
      let oldItem = this.LabelList[index];
      console.log('oldItem', oldItem);
      oldItem['isChecked'] = !oldItem['isChecked'];
      this.$set(this.LabelList, index, oldItem);
      this.selectLabelNoArr = [];
      this.LabelList.map(item => {
        if (item['isChecked']) {
          this.selectLabelNoArr.push({
            'labelNo': item.labelNo
          });
        }
      })
    },
    handleClick() {

    },
    handleChange() {

    },
    loadStudentDetal() {
      let params = {
        customId:this.currentCustomId
      }
      console.log('11111-11');
      customArticle(params).then(ret => {
        if (ret.code === 0) {
          this.studentData = ret.data;

          this.followUpForm.customName = this.studentData.customName;

          this.messageForm.customName = this.studentData.customName;
          this.messageForm.phone = this.studentData.phone;
          this.messageForm.relationStr = this.studentData.relationStr;
          this.messageForm.sex = this.studentData.sex;
          this.messageForm.birthday = this.studentData.birthdayStr;
          this.messageForm.homeAddress = this.studentData.homeAddress;
          this.messageForm.customType = this.studentData.customType;
          this.messageForm.stage = this.studentData.stage;
          this.messageForm.grade = this.studentData.grade;
          this.messageForm.school = this.studentData.school;

          this.messageForm.relationBackup = 6002001
          this.messageForm.phoneBackup = this.studentData.phoneBackup;
          this.messageForm.relationBackupTwo = 6002001;
          this.messageForm.phoneBackupTwo = this.studentData.phoneBackupTwo;
          this.messageForm.relationBackupThree = 6002001;
          this.messageForm.phoneBackupThree = this.studentData.phoneBackupThree;
          this.messageForm.remark = this.studentData.remark;
        }
        this.changeStage(this.studentData.stage);
      })
    },
    changeStage(val) {
      this.schools = this.schoolData[val];
    },
    changeSchool1(val) {
      if(val){
        queryBaseSchool({campusId:null,search:val}).then(res=>{
          if(res.code === 0 ){
            this.PublicSchool = res.data || [];
          }
        })
      }
    },
    submitSave() {
      if (this.activeName == 'first') { // 添加跟进
        this.addFollowUp();
      } else { // 完善资料
        this.saveCustomer();
      }
    },
    // 添加跟进
    addFollowUp() {
      let { intend, followStatus, communicateContent, pictures, communicateDate,
        communicateTime } = this.followUpForm;
      addRecord({
        operationType: 1,
        customId: this.currentCustomId,
        intend: intend || null,
        followStatus: followStatus || null,
        labels: this.selectLabelNoArr || [],
        communicateContent: communicateContent || '',
        pictures: this.uploadPictureObj.fileUrl,
        callStatus: this.selectCallStatus[0],
        nextCommunicateTime: communicateDate +' ' + communicateTime
      }).then(ret => {
          if (ret.code === 0) {
            this.$message({
              message: '保存成功',
              type: 'success'
            });
            this.dialogVisible = false;
            this.$emit('closeFollowUpDialog');
          } else {
            this.$message.warning(ret.message || "保存失败");
          }
      })
    },
    // 完善资料
    saveCustomer() {
      this.$refs['messageForm'].validate((valid) => {
        if (valid) {
          const { customName, sex, phone, relation, relationBackup, phoneBackup,
          relationBackupTwo, phoneBackupTwo, relationBackupThree,
          phoneBackupThree, birthday, homeAddress, stage, grade, firstSource,
          remark, customType, school, schoolId  } = this.messageForm;
          let params = {
            customId: this.studentData.customId,
            customName: customName,
            sex: sex || '',
            relation: relation ||6002001,
            phone: phone,
            relationBackup: relationBackup || 6002001,
            phoneBackup: phoneBackup,
            relationBackupTwo: relationBackupTwo || 6002001,
            phoneBackupTwo: phoneBackupTwo,
            relationBackupThree: relationBackupThree || 6002001,
            phoneBackupThree: phoneBackupThree,
            birthday: birthday,
            homeAddress: homeAddress || '',
            stage: stage,
            grade: grade,
            remark: remark || '',
            customType: customType,
            fromScreen: 1,
            school: school || '',
            schoolId: schoolId || '',
            ownerId : this.ownerId,
          }
          if (firstSource.length > 1) {
            params['firstSource'] = firstSource[1];
          } else {
            params['firstSource'] = '';
          }
          addEditCustomer(params).then(ret => {
            if (ret.code === 0) {
              this.$message({
                message: '保存成功',
                type: 'success'
              });
              this.dialogVisible = false;
              this.$emit('closeFollowUpDialog');
            }else{
              this.$message.warning(ret.message || "保存失败");
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    closeFollowUpDialog() {
      this.dialogVisible = false;
      this.$emit('closeFollowUpDialog');
    },
    previewImage() {

    },
    handleRemove() {
      this.fileList = [];
      this.upload_btn = false;
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleSetUploadData(item) {
      const isLt5M = item.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$refs.upload.clearFiles()
        this.$message({
          message: '上传文件大小不能超过 5MB!',
          type: 'warning'
        })
        return false
      }
      let FormDatas = new FormData();
      FormDatas.append("file", item.raw);
      let BASE_URL = getBaseUrl();
      axios
        .post(`${BASE_URL}base/upload/uploadPicture?type=record`, FormDatas, {
          headers: {
            "Content-Type": "multipart/form-data",
            authorization: LoginUserHelper.getUserToken()
          }
        })
        .then(res => {
          console.log("res", res);
          if (res.code == 0) {
            console.log("res.data", res.data);
            let { fileName, uploadPath } = res.data;
            // this.bankRransferForm.fileName = fileName;
            // this.bankRransferForm.fileUrl = uploadPath;
            this.uploadPictureObj['fileName'] = fileName;
            this.uploadPictureObj['fileUrl'] = uploadPath;
			      this.upload_btn = true;
          } else {
            this.$message.error(res.message);
          }
        });
    },
    handleExceed() {

     },
  },
}
</script>

<style lang="scss" scoped>
.MyDialog {
  .label-ul {
    margin-top: 10px;
    display: flex;
    flex-wrap: wrap;
    li {
      height: 20px;
      line-height: 20px;
      margin-right: 20px;
      margin-bottom: 10px;
      padding: 2px 10px;
      border-radius: 6px;
      &:hover{
        cursor: pointer;
      }
      &.actived {
        color: #fff;
        background-color: #4a83e8;
      }
    }
  }
  .tips {
    color: rgb(171, 171, 171);
  }
  .followUpForm {
      :deep(.el-form-item) {
        margin-bottom: 10px;
      }
    }
}
</style>